// extracted by mini-css-extract-plugin
export default {"root":"knowledge_root__AnBby","header":"knowledge_header__UKArh","headerTitle":"knowledge_headerTitle__h1y0y","navigatorContent":"knowledge_navigatorContent__KfOG1"};